export enum ClubView {
  FAVORITE = 1,
  LIST_ACTIVE = 3,
  LIST_INACTIVE = 4,
  SEARCH = 2,
  NEW = 12,
  // club detail
  DETAIL = 5,
  EDIT = 6,
  MEMBERS = 7,
  FEES = 8,
  BIRTH_NUMBERS = 9,
  CONTRACTS = 10,
  NSA = 11,
  EDIT_LOGO = 13,
  EDIT_HISTORY = 14,
  CANCEL = 15,
  BEACH = 16,
  GENERAL_CONTACTS = 17,
}
